import Transaksi from "./views/Transaksi";
import TransaksiDetail from "./views/TransaksiDetail";
import TransaksiStatus from "./views/TransaksiStatus";
import TransaksiNotaTambahan from "./views/TransaksiNotaTambahan";

const requireAuth = {requireAuth: true}
const route = {
	path: '/transaksi/reguler', component: {
		render(c) {
			return c('router-view')
		}
	},
	children: [
		{
			path: '',
			name: "TransaksiGlobal",
			component: Transaksi,
			meta: {
				...requireAuth,
				accessKey: 'transaction.transactionRegular',
			},
		},
		{
			path: 'detail',
			component: {
				render(c) {
					return c('router-view')
				}
			},
			children: [
				{
					path: ':idtransaksi',
					name: "TransaksiDetail",
					component: TransaksiDetail,
					meta: {
						...requireAuth,
						accessKey: 'transactionRegular.read'
					}
				},
				{
					path: 'status/:idtransaksi/:idWhitelabel?',
					name: "TransaksiStatus",
					component: TransaksiStatus,
					meta: {
						...requireAuth,
						accessKey: 'transactionRegular.read'
					},
					props: true
				},
				{
					path: 'nota_tambahan/:idantarextra',
					name: "TransaksiNotaTambahan",
					component: TransaksiNotaTambahan,
					meta: {
						...requireAuth,
						accessKey: 'transactionRegular.read'
					}
				}
			]
		}
	]
}


export default router => {
	router.addRoutes([route])
}